import { render, staticRenderFns } from "./BlockContactFormulier.vue?vue&type=template&id=465ece94&"
import script from "./BlockContactFormulier.vue?vue&type=script&lang=js&"
export * from "./BlockContactFormulier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports